export const taskExecutorQueues = [
    {
        value: "DEFAULT",
        label: "Default"
    },
    {
        value: "FAST_COMPUTE",
        label: "Fast Compute"
    },
]

